// extracted by mini-css-extract-plugin
module.exports = {"Root":"result_Root__3y3Tj","Paper":"result_Paper__3iLmJ"};